module.exports = __webpack_public_path__ + "static/media/starIcon.75898135.svg";